const STORAGE_KEY = "admin-cop-preview"

let _copPreviewId = localStorage.getItem(STORAGE_KEY) || null
const listeners = new Set()

export function getCopPreviewId() {
    return _copPreviewId
}

export function setCopPreviewId(id) {
    _copPreviewId = id || null
    if (id) localStorage.setItem(STORAGE_KEY, id)
    else localStorage.removeItem(STORAGE_KEY)
    listeners.forEach((fn) => fn(_copPreviewId))
}

export function subscribeCopPreview(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
}
